// hook code from
// https://medium.com/the-non-traditional-developer/how-to-use-an-intersectionobserver-in-a-react-hook-9fb061ac6cb5
import { useEffect, useRef, useState } from 'react';
import * as R from 'ramda';

const headLens = R.lensIndex(0);

// useIntersect takes three props
// root is the element to look for intersection changes, null defaults to viewport
// rootMargin is the amount of overscan, in pixels or percentages, numbers not allowed
// threshold is the ratio of the observed element that intersects the root element that causes the callback to fire
export default ({ root = null, rootMargin, threshold = 0 }) => {
  // this is the value we save the details returned from the intersection observer
  // this hook will save the entire object
  const [entry, updateEntry] = useState({});

  // this is the element to be watched
  // the hook allows you to set this node on mount by returning setNode
  const [node, setNode] = useState(null);

  // utilize a ref to store the observer so it doesn't change on rerender
  const observer = useRef(null);

  useEffect(() => {
    // disconnect the observer if there is already an observer present
    if (observer.current) observer.current.disconnect();

    // construct the observer
    observer.current = new IntersectionObserver(R.o(updateEntry, R.view(headLens)), {
      root,
      rootMargin,
      threshold,
    });

    // destructure the observer, so it is still available on cleanup
    const { current: currentObserver } = observer;

    // only observe if a node is present
    if (node) currentObserver.observe(node);

    // cleanup on unmount
    return () => currentObserver.disconnect();
  }, [node, root, rootMargin, threshold]);

  return { entry, setNode };
};
